"use strict";
import { AccountsESocialRelation } from "./accounts-esocial-relation.constant";
import "./accounts-esocial-relation-dialog.scss";

export class AccountsESocialRelationDialogCtrl {
    accountsESocialRelation = AccountsESocialRelation;

    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
    }

    $onInit() {
        console.log("$onInit");
    }
}

angular
    .module("nucont.shared")
    .controller("AccountsESocialRelationDialogCtrl", [
        "$mdDialog",
        "locals",
        AccountsESocialRelationDialogCtrl
    ]);
